import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PlanSelection from '../PlanSelection/PlanSelection';
import Inclusions from '../Inclusions/Inclusions';
import VehicleTow from '../Multiple/VehicleTow';
import ProceedButton from '../Multiple/ProceedButton';
import LocationTracker from '../LocationTracker';
import '../../styles/global.css';
import '../../styles/loader.css';
import './Body.css';
import {checkCustomer,setIsNewCustomer,verifyUser} from '../../store/reducers/profileReducer';
import { setOtpVerified } from '../../store/reducers/flowStepReducer';
import { useNavigate } from 'react-router-dom';
import { parseMobileParamsNew, isEncrypted } from './../../utils/Common.js';
import { showAlert } from '../../store/reducers/alertReducer';
import { GB_URL } from '../../utils/Constants';

const defaultItems = [
  { icon: '/assets/inclusion/cab-assistance.svg', value: 'Cab Assistance' },
  { icon: '/assets/inclusion/emergency-accident.svg', value: 'Emergency Accident Towing Assistance' },
  { icon: '/assets/inclusion/key.svg', value: 'Car Key Repairs' },
  { icon: '/assets/inclusion/emergency-accident.svg', value: 'Emergency Car Breakdown Services' },
  { icon: '/assets/inclusion/house.svg', value: 'Accommodation' },
  { icon: '/assets/inclusion/tyre.svg', value: 'Flat Tyre Service' },
  { icon: '/assets/inclusion/fuel.svg', value: 'Emergency Fuel Delivery' },
  { icon: '/assets/inclusion/coverage.svg', value: 'Coverage Area Emergency' },
];

function Body() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileResponse = useSelector((state) => state.profileList);
  const profileData = profileResponse.profileData || {};
  const accessData = profileResponse.tokenData || {};
  const { error } = useSelector(
    (state) => state.profileList
);

  // const {tokenData: accessData1,error } = profileResponse;

  console.log("accessData",accessData);
  console.log("profileResponseprofileResponse",profileResponse);
  const [vehicleType, setVehicleType] = useState(null);
  const [plan, setPlan] = useState(null);
  const [verifiedData, setVerifiedData] = useState(null);

  useEffect(() => {

    const initializeUser = async () => {

        console.log(
            "Before clear localstorage:",
            JSON.parse(localStorage.getItem('customerProfile'))
        );

        localStorage.removeItem('customerProfile');

        console.log(
            "After clear localstorage:",
            JSON.parse(localStorage.getItem('customerProfile'))
        );

        const parsed = parseMobileParamsNew();

        console.log("parsed123:", parsed);

        if (!parsed) {
            dispatch(setIsNewCustomer(true));
            console.log('Mobile number not found in Redux state');
            return;
        }

        try {

            console.log("parsed:", parsed);

            setVerifiedData(parsed.verifiedData);

            const verifiedData = parsed.verifiedData;
            const mobileNumber = parsed.mobileNumber;

            if (parsed.source === 'cholaone') {
                dispatch(setOtpVerified(false));
            } else {
                dispatch(setOtpVerified(true));
            }

            localStorage.setItem(
                'mblnbr',
                JSON.stringify(mobileNumber)
            );

            // Step 1: Verify user
            const vuser = await dispatch(
                verifyUser(verifiedData)
            ).unwrap();

            console.log("verifyUser response:", vuser);

            // Step 2: Only if verifyUser succeeded
            const cuser = await dispatch(
                checkCustomer(verifiedData)
            ).unwrap();

            console.log("checkCustomer response:", cuser);

        } catch (error) {

            console.error("Verification failed:", error);

            dispatch(
                showAlert({
                    type: 'error',
                    message:
                        error?.message ||
                        'Session Already Used.'
                })
            );
            setTimeout(() => {
              window.location.href = GB_URL;
          }, 1000);

        }
    };

    initializeUser();

}, [dispatch, navigate]);

  useEffect(() => {

      if (accessData?.access_token) {

          dispatch(checkCustomer(verifiedData));

      }

  }, [accessData,verifiedData]);

 

  useEffect(() => {

      if (error) {

          dispatch(
              showAlert({
                  type: 'error',
                  message: error
              })
          );

          // navigate('/');
      }

  }, [error, dispatch, navigate]);

  return (
    <main className="body membership">
      <div className="section-one">
        <VehicleTow />
        {/* <LocationTracker /> */}
      </div>
      <PlanSelection onSelect={setVehicleType} />
      <Inclusions  vehicleType={vehicleType} />
      <ProceedButton />
    </main>
  );
}

export default Body;
